interface ClonePropsProps<T> {
  children: (props: T) => JSX.Element;
}

export function CloneProps<T>(props: ClonePropsProps<T>) {
  const { children, ...other } = props;
  return children(other as T);
}
